/** @velyn-custom BEGIN — vely-comparison-table.js (accessible tab switching for comparison table) */
(function () {
  class VelyComparisonTable extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cmpBound === "true") return;
      this.dataset.cmpBound = "true";

      this.tabs = Array.from(this.querySelectorAll("[data-cmp-tab]"));
      this.panels = Array.from(this.querySelectorAll("[data-cmp-panel]"));

      if (this.panels.length === 0) return;

      if (this.tabs.length > 0) {
        this.tabs.forEach((tab) => {
          tab.addEventListener("click", () => this.activateTab(tab));
          tab.addEventListener("keydown", (event) => this.onTabKeydown(event, tab));
        });
      } else {
        const panel = this.panels[0];
        if (panel) {
          panel.classList.add("is-active");
          panel.hidden = false;
        }
      }

      this.positionFeaturedHighlights();
      if (!this._cmpResizeBound) {
        this._cmpResizeBound = true;
        let resizeTimer;
        window.addEventListener(
          "resize",
          () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => this.positionFeaturedHighlights(), 120);
          },
          { passive: true },
        );
      }

      if (window.Shopify?.designMode) {
        document.addEventListener("shopify:section:load", (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) {
            this.syncFromDom();
          }
        });
      }
    }

    syncFromDom() {
      this.tabs = Array.from(this.querySelectorAll("[data-cmp-tab]"));
      this.panels = Array.from(this.querySelectorAll("[data-cmp-panel]"));
      const active = this.tabs.find((tab) => tab.classList.contains("is-active")) || this.tabs[0];
      if (active) this.activateTab(active, true);
      this.positionFeaturedHighlights();
    }

    activateTab(tab, silent) {
      const target = tab.getAttribute("data-cmp-tab");
      if (!target) return;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", isActive ? "true" : "false");
        item.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.getAttribute("data-cmp-panel") === target;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
      });

      if (!silent) tab.focus();
      this.positionFeaturedHighlights();
    }

    positionFeaturedHighlights() {
      const panel =
        this.panels.find((p) => p.classList.contains("is-active") && !p.hidden) ||
        this.panels.find((p) => !p.hidden);

      if (!panel) return;

      const container = panel.querySelector(".vely-cmp__panel-inner");
      const table = panel.querySelector(".vely-cmp__table");
      const highlight = panel.querySelector(".vely-cmp__featured-highlight");

      if (!container || !table || !highlight) return;

      requestAnimationFrame(() => {
        const containerRect = container.getBoundingClientRect();
        const tableRect = table.getBoundingClientRect();

        /* left/width come from CSS (desktop 424/352, mobile 160/352) */
        highlight.style.left = "";
        highlight.style.width = "";
        highlight.style.top = `${tableRect.top - containerRect.top}px`;
        highlight.style.height = `${tableRect.height}px`;
        highlight.style.bottom = "auto";
      });
    }

    onTabKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      if (index < 0) return;

      let nextIndex = null;
      if (event.key === "ArrowRight") nextIndex = (index + 1) % this.tabs.length;
      if (event.key === "ArrowLeft") nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === "Home") nextIndex = 0;
      if (event.key === "End") nextIndex = this.tabs.length - 1;

      if (nextIndex !== null) {
        event.preventDefault();
        this.activateTab(this.tabs[nextIndex]);
      }
    }
  }

  if (!customElements.get("vely-comparison-table")) {
    customElements.define("vely-comparison-table", VelyComparisonTable);
  }
})();
/** @velyn-custom END — vely-comparison-table.js */
